import { render, staticRenderFns } from "./VisitInstitute.vue?vue&type=template&id=bc77de00&scoped=true"
import script from "./VisitInstitute.vue?vue&type=script&lang=ts"
export * from "./VisitInstitute.vue?vue&type=script&lang=ts"
import style0 from "./VisitInstitute.vue?vue&type=style&index=0&id=bc77de00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc77de00",
  null
  
)

export default component.exports